/**
 * Per-publication subdomain for the external embed domain.
 *
 * The djb2 hash is deliberately plain and synchronous so server rendering can build the
 * URL without awaiting anything. Both the URL builders and the loader that answers those
 * URLs derive the subdomain here, so a change cannot desynchronise them.
 */
export function embedSubdomain(publicationHostname: string): string {
  const hostname = publicationHostname.toLowerCase().replace(/^www\./, '');

  let hash = 5381;
  for (let index = 0; index < hostname.length; index++) {
    hash = (hash * 33) ^ hostname.charCodeAt(index);
  }

  return Math.abs(hash).toString(36);
}
